/* Selector de personalizacion en la ficha de la pelota.
   Al comprar manda un solo POST con los dos renglones, para que Dawn no
   quede con indices de linea desfasados. */
(function () {
  var nativeFetch = window.fetch.bind(window);
  var MAX = 5;
  var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 });
  var busy = false;

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(c) { return fmt.format(c / 100); }
  function num(el, a) { return parseInt(el.getAttribute(a), 10) || 0; }

  function clean(v) {
    return (v || '')
      .toUpperCase()
      .replace(/[^A-ZÁÉÍÓÚÑ&.\- ]/g, '')
      .replace(/\s{2,}/g, ' ')
      .slice(0, MAX);
  }

  function form() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function currentVariant() {
    var f = form();
    var i = f && f.querySelector('[name="id"]');
    return i ? parseInt(i.value, 10) : 0;
  }

  /* El precio base sigue a la variante elegida (12 / 20 / 30 unidades). */
  function base(root) {
    var map = {};
    try { map = JSON.parse(root.getAttribute('data-prices') || '{}'); } catch (e) {}
    var id = currentVariant();
    if (id && map[id] != null) return map[id];
    return num(root, 'data-base');
  }

  function mode(root) {
    var checked = root.querySelector('input[name="mb-bp-mode"]:checked');
    return checked ? checked.value : 'none';
  }

  function colorOf(root) {
    var c = root.querySelector('[data-mb-perso-color]:checked');
    return c ? c.value : 'Negro';
  }

  function textOf(root) {
    var i = root.querySelector('[data-mb-perso-input]');
    return i ? clean(i.value) : '';
  }

  /* --- Reacomodo sobre el bloque de suscripcion --- */
  function findSub(root) {
    var scope = document.querySelector('.product__info-container') || document.body;
    var all = scope.querySelectorAll('*');
    var best = null;
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === root || el.contains(root)) continue;
      var t = (el.textContent || '').toLowerCase();
      if (t.indexOf('opciones de compra') === -1 && t.indexOf('flight club') === -1) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }

  function hoist(root) {
    var sub = findSub(root);
    if (!sub) return;
    var node = sub;
    while (node && node.parentNode && !node.parentNode.contains(root)) node = node.parentNode;
    if (!node || !node.parentNode || node === root || node.contains(root)) return;
    if (root.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING) return;
    node.parentNode.insertBefore(root, node);
  }

  function paint(root) {
    var m = mode(root);
    var panelIni = root.querySelector('[data-mb-bp-panel-ini]');
    var panelCar = root.querySelector('[data-mb-bp-panel-car]');
    var total = root.querySelector('[data-mb-bp-total]');
    var err = root.querySelector('[data-mb-bp-error]');

    if (panelIni) panelIni.hidden = m !== 'ini';
    if (panelCar) panelCar.hidden = m !== 'car';
    if (err) err.hidden = true;

    var b = base(root);
    var extra = 0;
    if (m === 'ini') extra = num(root, 'data-ini-price');
    if (m === 'car') extra = num(root, 'data-car-price');

    if (total) {
      if (extra > 0) {
        total.hidden = false;
        total.innerHTML = 'Total: <b>' + money(b + extra) + '</b> <span>' + money(b) + ' las pelotas + ' + money(extra) + ' de personalización</span>';
      } else {
        total.hidden = true;
      }
    }

    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span) return;
      if (!btn.getAttribute('data-mb-label')) btn.setAttribute('data-mb-label', span.textContent.trim());
      span.textContent = extra > 0 ? 'Agregar al carrito con personalización' : btn.getAttribute('data-mb-label');
    });

    document.querySelectorAll('.product-form__buttons .shopify-payment-button').forEach(function (el) {
      el.style.display = extra > 0 ? 'none' : '';
    });
  }

  function wirePreview(root) {
    var input = root.querySelector('[data-mb-perso-input]');
    var out = root.querySelector('[data-mb-perso-text]');
    var count = root.querySelector('[data-mb-perso-count]');
    var name = root.querySelector('[data-mb-perso-colorname]');

    function pt() {
      if (!input) return;
      var v = clean(input.value);
      if (input.value !== v) input.value = v;
      if (out) { out.textContent = v; out.classList.toggle('is-on', v.length > 0); }
      if (count) count.textContent = String(MAX - v.length);
    }

    if (input) { input.addEventListener('input', pt); input.addEventListener('blur', pt); }

    root.querySelectorAll('[data-mb-perso-color]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (out) out.style.color = radio.getAttribute('data-mb-perso-color');
        if (name) name.textContent = radio.value;
      });
      if (radio.checked && out) {
        out.style.color = radio.getAttribute('data-mb-perso-color');
        if (name) name.textContent = radio.value;
      }
    });

    pt();
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var cd = drawerEl();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return null;
  }

  function submit(f, root) {
    if (busy) return;
    var m = mode(root);
    var variantId = currentVariant();
    var qtyInput = f.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId) return;

    var items = [{ id: variantId, quantity: qty }];

    if (m === 'ini') {
      var text = textOf(root);
      if (!text) {
        var err = root.querySelector('[data-mb-bp-error]');
        if (err) err.hidden = false;
        var input = root.querySelector('[data-mb-perso-input]');
        if (input) { input.focus(); input.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      items.push({
        id: num(root, 'data-ini-id'),
        quantity: 1,
        properties: { Iniciales: text, 'Color de tinta': colorOf(root) }
      });
    } else if (m === 'car') {
      items.push({ id: num(root, 'data-car-id'), quantity: 1 });
    }

    busy = true;
    var btn = f.querySelector('.product-form__submit');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var payload = { items: items };
    var ids = sectionIds();
    if (ids) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }

    nativeFetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
        var cd = drawerEl();
        if (cd && json && json.sections && typeof cd.renderContents === 'function') {
          try { cd.renderContents(json); } catch (e) {}
          document.dispatchEvent(new CustomEvent('mb:cart:changed'));
          return;
        }
        window.location = routeRoot() + 'cart';
      })
      .catch(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
        window.location = routeRoot() + 'cart';
      });
  }

  function init() {
    var root = document.querySelector('[data-mb-bp]');
    if (!root) return;

    if (root.dataset.mbBound !== '1') {
      root.dataset.mbBound = '1';
      wirePreview(root);

      root.querySelectorAll('input[name="mb-bp-mode"]').forEach(function (r) {
        r.addEventListener('change', function () { paint(root); });
      });

      /* Cambio de presentacion (12 / 20 / 30): el total debe seguir al precio. */
      document.addEventListener('change', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('variant-selects, variant-radios, .product-form__input, .product-variant-id')) {
          setTimeout(function () { paint(root); }, 80);
        }
      });

      document.addEventListener(
        'submit',
        function (e) {
          var f = e.target;
          if (!f || f.getAttribute('data-type') !== 'add-to-cart-form') return;
          if (mode(root) === 'none') return;
          e.preventDefault();
          e.stopPropagation();
          submit(f, root);
        },
        true
      );

      if (window.MutationObserver) {
        var scope = document.querySelector('.product__info-container');
        if (scope) {
          var pending = null;
          new MutationObserver(function () {
            clearTimeout(pending);
            pending = setTimeout(function () { hoist(root); paint(root); }, 140);
          }).observe(scope, { childList: true, subtree: true });
        }
      }

      paint(root);
    }

    hoist(root);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
  setTimeout(init, 600);
  setTimeout(init, 1600);
  setTimeout(init, 3200);
})();
